import { useCaCookies } from '@/modules/CA/cookies/context/use-ca-cookies';
import React, { PropsWithChildren, useMemo } from 'react';
import { CaApiSdkManager } from '../utils/ca-api-sdk-manager';
import { CaApiSdkContext } from './ca-api-sdk-context';

export const CaApiSdkProvider: React.FC<PropsWithChildren> = (props) => {
  const { token, apiUrl } = useCaCookies();

  const sdk = useMemo(() => CaApiSdkManager.createSdk(token, apiUrl), [token, apiUrl]);

  return <CaApiSdkContext.Provider value={sdk}>{props.children}</CaApiSdkContext.Provider>;
};
